import { useState } from "react";
import PropTypes from "prop-types";

import GridCheckbox from "../ui/checkbox/GridCheckbox";

// Function for rendering the checkbox column
const RenderGridCheckboxColumn = ({
  rowData,
  col,
  rowIndex,
  onColumnDataChange
}) => {

  const [value, setValue] = useState(rowData[col.fieldName]);
  const { colSettings, fieldName } = col;
  const isDisabled = colSettings?.isDisabled || false;

  const handleCheckboxChange = (e) => {
    const newValue = !value;
    setValue(newValue);

    if (onColumnDataChange) {
      const newRowData = { ...rowData, [fieldName]: newValue };
      onColumnDataChange(fieldName, newRowData, rowIndex);
    }
  };

  return (
    <GridCheckbox
      type="checkbox"
      checked={value}
      disabled={isDisabled}
      onChange={(handleCheckboxChange)}
    />
  );
};

RenderGridCheckboxColumn.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.shape({
    colSettings: PropTypes.object,
    fieldName: PropTypes.string.isRequired
  }).isRequired,
  rowIndex: PropTypes.number.isRequired,
  onColumnDataChange: PropTypes.func
};

export default RenderGridCheckboxColumn